module.exports = __webpack_public_path__ + "static/letterboxbibmain-e9eb2d99d98db8252608aee01c5d102c.png";